import { Component, Inject } from "@angular/core";
import { LicenseService } from "../../../services/LicenseService";
import { MD_DIALOG_DATA, MdDialogRef } from "@angular/material";
import { ViewScal360PurchaseHistoryComponent } from "../view-scal360-purchase-history/view-scal360-purchase-history.component";
import { SCALType } from "../../../interfaces/LicenseModel";
import { Router } from "@angular/router";
import { AdalService } from "../../../shared/adal.service";

@Component({
    template:require('./view-scal360-renewal-history.component.html'),
    styles:[require('./view-scal360-renewal-history.component.css')],
    selector:'view-scal360-renewal-history'
})
export class ViewScal360RenewalHistoryComponent{
    dialogTitle='View SCAL 360 Renewal History'
    errorMessage='';
    Scal360LicenseRenewalHistory;
    SelectedCustomerLicenseDetail;
    SCALTypeEnum=SCALType
    scal360LicenseDisplayList;
    isLoading=false;
    constructor(
        private licenseService:LicenseService,
        public dialogRef:MdDialogRef<ViewScal360RenewalHistoryComponent>,
        private adalService:AdalService,
                private router:Router,
        @Inject(MD_DIALOG_DATA) public dialogData:any,
    ){
        if (!this.adalService.getCachedToken()) {
            this.dialogRef.close(null);
            this.router.navigate(["login"]);
        }
        else{
            this.scal360LicenseDisplayList=this.dialogData.Scal360LicenseData;
            this.SelectedCustomerLicenseDetail=this.dialogData.SelectedLicenseDetail;
            this.getScal360LicenseRenewalHistory()
        }
    }
    getScal360LicenseRenewalHistory(){
        this.isLoading=true;
        this.licenseService.getScalLicenseRenewalHistory(this.SelectedCustomerLicenseDetail.LicenseDetailId).subscribe((data)=>{
            if(!data.IsError && data.DataObject!=null){
                this.Scal360LicenseRenewalHistory=data.DataObject;
            }
            else{
                this.errorMessage=data.Error;
            }
            this.isLoading=false;
        })
    }
    onCancel(){
        this.dialogRef.close(this.scal360LicenseDisplayList)
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/license-portal/scal360/view-scal360-renewal-history/view-scal360-renewal-history.component.ts